'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2; /* eslint-disable */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// fruit options
var LESS_THAN_HALF = 'Less than 1/2 serving';
var HALF_SERVING = '1/2 serving';
var ONE_SERVING = '1 serving';
var ONE_HALF_SERVING = '1 1/2 servings';
var TWO_SERVING = '2 servings';

// vegetable options
var LESS_THAN_TWO_SERVINGS = '2 servings or less';
var TWO_AND_HALF_SERVINGS = '2 1/2 servings';
var THREE_SERVINGS = '3 servings';
var THREE_AND_HALF_SERVINGS = '3 1/2 servings';
var FOUR_SERVINGS = '4 servings';
var FOUR_AND_HALF_SERVINGS = '4 1/2 servings';
var FIVE_SERVINGS = '5 servings';
var FIVE_AND_HALF_SERVINGS = '5 1/2 servings';

var Module1App4 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module1,
    app: state.moduleData.data.module1.app4,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App4, _Component);

  function Module1App4() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App4.__proto__ || (0, _getPrototypeOf2.default)(Module1App4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 4,
      isCompleted: _this.props.app.isCompleted || false,
      fruitServings: _this.props.app.fruitServings || 'Fruit', // how many fruit servings
      vegeServings: _this.props.app.vegeServings || 'Vegetable', // how many vegetable servings
      fruitdrop: [{
        option: LESS_THAN_HALF,
        text: '< 0.5'
      }, {
        option: HALF_SERVING,
        text: '0.5'
      }, {
        option: ONE_SERVING,
        text: '1'
      }, {
        option: ONE_HALF_SERVING,
        text: '1.5'
      }, {
        option: TWO_SERVING,
        text: '2'
      }],
      vegetabledrop: [{
        option: LESS_THAN_TWO_SERVINGS,
        text: '< 2'
      }, {
        option: TWO_AND_HALF_SERVINGS,
        text: '2.5'
      }, {
        option: THREE_SERVINGS,
        text: '3'
      }, {
        option: THREE_AND_HALF_SERVINGS,
        text: '3.5'
      }, {
        option: FOUR_SERVINGS,
        text: '4'
      }, {
        option: FOUR_AND_HALF_SERVINGS,
        text: '4.5'
      }, {
        option: FIVE_SERVINGS,
        text: '5'
      }, {
        option: FIVE_AND_HALF_SERVINGS,
        text: '5.5'
      }],
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.convertISOTimeToAge = function () {
      var now = new Date();
      var date = new Date(_this.props.profile.childDOB);
      var yearDiff = now.getFullYear() - date.getFullYear();
      var monthDiff = now.getMonth() - date.getMonth();
      var dayDiff = now.getDay() - date.getDay();

      if (monthDiff < 0) {
        yearDiff--;
      } else if (monthDiff === 0) {
        if (dayDiff < 0) {
          yearDiff--;
        }
      }
      return yearDiff;
    }, _this.handleFruit = function (event) {
      var obj = _this.state;
      obj.fruitServings = _this.state.fruitdrop[event - 1].text;
      _this.setState(obj);
    }, _this.handleVegetable = function (event) {
      var obj = _this.state;
      obj.vegeServings = _this.state.vegetabledrop[event - 1].text;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * User changes the fruit servings selection
   */


  /*
   * User changes the vegetable servings selection
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1App4, [{
    key: 'getRecomVege',
    value: function getRecomVege(age) {
      if (age <= 3) return 2.5;
      if (age <= 8) return 4.5;
      if (this.props.profile.childGender === 'Male' && age >= 9) return 5.5;
      if ((this.props.profile.childGender === 'Female' || this.props.profile.childGender === 'Other') && age >= 9) return 5;
    }
  }, {
    key: 'getRecomFruit',
    value: function getRecomFruit(age) {
      if (age <= 3) return 1;
      if (age <= 8) return 1.5;

      return 2;
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var styles = require('../../Modules.scss');
      var age = this.convertISOTimeToAge();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Is your child getting the recommended number of serves?'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'h4',
                null,
                'Is ',
                this.props.profile.childName,
                ' getting the recommended number of serves for each day?'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                'Our dietitian has calculated the amount of fruit and vegetables that ',
                this.props.profile.childName,
                ' has in a day and here are the results compared to the recommended serves for his/her age.'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                ReactBootstrap.Table,
                { striped: true, bordered: true },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('td', null),
                    _react2.default.createElement(
                      'td',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      'Fruit'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'What is recommended:'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      this.getRecomVege(age)
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      this.getRecomFruit(age)
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'What ',
                      this.props.profile.childName,
                      ' has:'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(
                        ReactBootstrap.DropdownButton,
                        { title: this.state.vegeServings + ' servings', id: 'vegetableservings', onSelect: this.handleVegetable.bind(this) },
                        this.state.vegetabledrop.map(function (item, index) {
                          return _react2.default.createElement(
                            ReactBootstrap.MenuItem,
                            { eventKey: index + 1, key: 'vegedrop' + index },
                            item.option
                          );
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(
                        ReactBootstrap.DropdownButton,
                        { title: this.state.fruitServings + ' servings', id: 'fruitservings', onSelect: this.handleFruit.bind(this) },
                        this.state.fruitdrop.map(function (item, index) {
                          return _react2.default.createElement(
                            ReactBootstrap.MenuItem,
                            { eventKey: index + 1, key: 'fruitdrop' + index },
                            item.option
                          );
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Feedback: '
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      age <= 3 && this.state.vegeServings === '2.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age <= 3 && this.state.vegeServings === '2' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age <= 3 && this.state.vegeServings === '< 2' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 4 && age <= 8 && this.state.vegeServings === '4.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 4 && age <= 8 && (this.state.vegeServings === '4' || this.state.vegeServings === '3.5') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 4 && age <= 8 && (this.state.vegeServings === '3' || this.state.vegeServings === '2.5' || this.state.vegeServings === '< 2') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 9 && age <= 11 && this.props.profile.childGender === 'Male' && this.state.vegeServings === '5.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 9 && age <= 11 && this.props.profile.childGender === 'Male' && (this.state.vegeServings === '5' || this.state.vegeServings === '4.5') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 9 && age <= 11 && this.props.profile.childGender === 'Male' && (this.state.vegeServings === '4' || this.state.vegeServings === '3.5' || this.state.vegeServings === '3' || this.state.vegeServings === '2.5' || this.state.vegeServings === '2') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 9 && age <= 11 && this.props.profile.childGender === 'Female' && this.state.vegeServings === '5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 9 && age <= 11 && this.props.profile.childGender === 'Female' && (this.state.vegeServings === '4.5' || this.state.vegeServings === '4') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 9 && age <= 11 && this.props.profile.childGender === 'Female' && (this.state.vegeServings === '3.5' || this.state.vegeServings === '3' || this.state.vegeServings === '2.5' || this.state.vegeServings === '2') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 12 && this.props.profile.childGender === 'Male' && this.state.vegeServings === '5.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 12 && this.props.profile.childGender === 'Male' && (this.state.vegeServings === '5' || this.state.vegeServings === '4.5') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 12 && this.props.profile.childGender === 'Male' && (this.state.vegeServings === '4' || this.state.vegeServings === '3.5' || this.state.vegeServings === '3' || this.state.vegeServings === '2.5' || this.state.vegeServings === '2') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 12 && this.props.profile.childGender === 'Female' && this.state.vegeServings === '5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 12 && this.props.profile.childGender === 'Female' && (this.state.vegeServings === '4.5' || this.state.vegeServings === '4') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 12 && this.props.profile.childGender === 'Female' && (this.state.vegeServings === '3.5' || this.state.vegeServings === '3' || this.state.vegeServings === '2.5' || this.state.vegeServings === '2') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      age <= 3 && this.state.fruitServings === '1' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age <= 3 && this.state.fruitServings === '0.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age <= 3 && this.state.fruitServings === '< 0.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 4 && age <= 8 && this.state.fruitServings === '1.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 4 && age <= 8 && this.state.fruitServings === '1' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 4 && age <= 8 && this.state.fruitServings === '< 0.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      ),
                      age >= 9 && this.state.fruitServings === '2' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Fantastic!'
                        )
                      ),
                      age >= 9 && this.state.fruitServings === '1.5' && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Almost there!'
                        )
                      ),
                      age >= 9 && (this.state.fruitServings === '1' || this.state.fruitServings === '0.5' || this.state.fruitServings === '< 0.5') && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'Something we can work on'
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  'An example of vegetable serves in a day'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  this.props.profile.childName,
                  ' needs ',
                  this.getRecomVege(age),
                  ' per day and could look like this:-'
                ),
                age <= 3 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h5',
                    null,
                    '2.5 serves (2 - 3 years):'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        '1/2 cup grated carrot on a sandwich at lunch (1 serve) + 1/2 medium potato and 3/4 cup broccoli at dinner (1-2 florets) (1.5 serves)'
                      )
                    )
                  )
                ),
                age >= 4 && age <= 8 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h5',
                    null,
                    '4.5 serves (4 - 8 years):'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        '1/2 cup grated carrot and 1/2 sliced tomato on a sandwich at lunch (1.5 serves)'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        '1 medium potato and 1/2 cup broccoli at dinner (3 serves)'
                      )
                    )
                  )
                ),
                age >= 9 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h5',
                    null,
                    '5 serves (9 - 13 years)'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        '1/2 cup grated carrot and 1/2 sliced tomato on a sandwich at lunch (1.5 serves)'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        '1/2 cup cucumber sticks with hummus for afternoon tea (1/2 serve)'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        '1 medium potato and 1/2 cup broccoli at dinner (3 serves)'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Keep in mind that these are just suggestions - find what works for you but it would great if you can try to provide different kinds of vegetables across the day.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For most kids vegetables need to be provided at lunch and possibly a snack or two, so that they achieve the recommended number of daily serves. This also puts less pressure on parents at dinner time, because you know that your child has had at least some vegies during the day - we hope!'
                ),
                _react2.default.createElement('div', { className: styles.spacer20 }),
                _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
                _react2.default.createElement('div', { className: styles.spacer100 })
              ),
              '// }'
            )
          )
        )
      );
    }
  }]);
  return Module1App4;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  module: _propTypes2.default.number,
  modtype: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
/* eslint-enable */

exports.default = Module1App4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App4.js
// module id = 1167
// module chunks = 0